function calcVideoSize(el) {
    const aspectRatio = el.is('[data-aspect-ratio]') ? el.data('aspect-ratio') : 0.5625;

    const width = el.outerWidth(true);
    const height = el.outerHeight(true);
    const newAspectRatio = height / width;
    let newWidth = 0;
    let newHeight = 0;

    if(newAspectRatio < aspectRatio) {
        newHeight = width * aspectRatio;
        newWidth = newHeight / aspectRatio;
    } else {
        newWidth = height / aspectRatio;
        newHeight = newWidth * aspectRatio;
    }

    return [newWidth, newHeight];
}

let _x = 0;
const Videos = (() => {
    const players = [];
    const queue = [];

    class Videos {
        add($video) {
            if (!queue.includes($video)) {
                queue.push($video);
            }
        }

        loadApi(isYoutube) {
            var self = this;
            queue.forEach(el => {
                if(el.data('video-type') !== "youtube") {
                    self.createVideo(el);
                }
            });

            if(isYoutube) {
                const tag = document.createElement('script');
                tag.src = "https://www.youtube.com/iframe_api";
                const firstScriptTag = document.getElementsByTagName('script')[0];
                firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

                
                window.onYouTubeIframeAPIReady = () => {
                    queue.forEach(el => {
                        if(el.data('video-type') === "youtube") {
                            self.createVideo(el);
                        }
                    });
                };
            }
        }

        createVideo($video) {
            _x += 1;
            const _num = Date.now();
            const prefix = _x + '_' + _num;
            $video.attr('data-prefix', prefix);

            if ($video.data("display-type") === "popup") {
                $video.find('.btn.btn-play, [data-play]').on('click', event => {
                    event.preventDefault();
                    const newId = $video.attr("data-id") + prefix;
                    if ($('#popup-' + newId).length === 0) {
                        const $popupVideo = document.createElement('div');
                        $popupVideo.setAttribute('id', `popup-${newId}`);

                        const $popupWrapper = document.createElement('section');
                        $popupWrapper.classList.add('w-video');
                        $popupWrapper.setAttribute('data-popup-video-id', newId);
                        $popupWrapper.setAttribute('data-popup-content', '');

                        const $overlay = document.createElement('span');
                        $overlay.classList.add('overlay');
                        $overlay.setAttribute('data-video-close', '');

                        const $wrap = document.createElement('div');
                        $wrap.classList.add('wrap');

                        const $content = document.createElement('div');
                        $content.setAttribute('data-video-content', '');

                        const $close = document.createElement('a');
                        $close.classList.add('close');
                        $close.setAttribute('href', '#');
                        $close.setAttribute('data-video-close', '');
                        $close.innerHTML = '<span class="icon-close text-blue-100"><svg width="30" height="29" viewBox="0 0 30 29" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.9292 21.2131L22.0713 7.071" stroke="#fff" stroke-width="1.5"/><path d="M22.0713 21.2131L7.92915 7.071" stroke="#fff" stroke-width="1.5"/></svg></span>';

                        $popupWrapper.appendChild($overlay);
                        $wrap.appendChild($content);
                        $wrap.appendChild($close);
                        $popupWrapper.appendChild($wrap);
                        $content.appendChild($popupVideo);
                        document.body.appendChild($popupWrapper);

                        // Create the YT player
                        const popupPlayer = new YT.Player(`popup-${newId}`, {
                            width: "100%",
                            height: "100%",
                            videoId: $video.attr("data-id"),
                            playerVars: {
                                'loop': 1,
                                'controls': 1,
                                'enablejsapi': 1,
                                'playsinline': 1,
                                'rel': 0,
                                'showinfo': 0
                            },
                            events: {
                                'onReady': onPlayerReady
                            }
                        });

                        function onPlayerReady(event) {
                            event.target.playVideo();
                        }

                        const op = {
                            "key": prefix,
                            "value": popupPlayer,
                            "videoType": $video.attr("data-video-type")
                        }

                        players.push(op);
                    } else {
                        players.forEach(player => {
                            if (player.key === prefix) {
                                player.value.playVideo();
                            }
                        });
                    }

                    const $ele = ($video.data("display-type") === "popup") ? $(`[data-popup-video-id="${newId}"]`) : $video;
                    $ele.addClass('playing on');
                    closeVideo($ele, prefix);
                });
            }

            if ($video.data("display-type") === "background") {
                let _size = calcVideoSize($video);
                $video.find('video').css({
                    width: _size[0],
                    height: _size[1]
                });
                
                $(window).resize(function(event) {
                    _size = calcVideoSize($video);
                    $video.find('video').css({
                        width: _size[0],
                        height: _size[1]
                    });

                    setTimeout(function() {
                        _size = calcVideoSize($video);
                        $video.find('video').css({
                            width: _size[0],
                            height: _size[1]
                        });
                    }, 300);

                    setTimeout(function() {
                        _size = calcVideoSize($video);
                        $video.find('video').css({
                            width: _size[0],
                            height: _size[1]
                        });
                    }, 600);

                    setTimeout(function() {
                        _size = calcVideoSize($video);
                        $video.find('video').css({
                            width: _size[0],
                            height: _size[1]
                        });
                    }, 1000);
                });

                if($video.data("video-type") == "mp4") {
                    const _ele = $video;
                    const _video = $video.find('video').get(0);

                    if($video.find('video:visible').is('[data-src]')) {
                        _video.src = $video.find('video:visible').data('src');
                        $video.find('video:visible').removeAttr('data-src');
                    } else {
                        $(window).resize(function(event) {
                            if($video.find('video:visible').is('[data-src]')) {
                                _video.src = $video.find('video:visible').data('src');
                                $video.find('video:visible').removeAttr('data-src');
                            }
                        });
                    }

                    _video.addEventListener('loadeddata', function() {
                        _ele.addClass('ready');
                        if(_video.readyState >= 2) {
                            if($video.is('[data-autoplay]')) {
                                _ele.addClass('playing');
                                _video.play().catch((error) => {
                                    fixMobileAutoplayLowerMode(_video);
                                });

                                setTimeout(function() {
                                    _video.play().catch((error) => {
                                        fixMobileAutoplayLowerMode(_video);
                                    });
                                }, 500);

                                $('body').on('click touchstart', function () {
                                    if(!$video.is('[data-trigger-play]')) {
                                        _video.play();
                                        $video.attr('data-trigger-play', 'true');
                                    }
                                    
                                });

                                _video.addEventListener('play', () => {
                                    $video.attr('data-trigger-play', 'true');
                                });
                            }
                        }
                    });

                    let _op = {
                        "key": prefix,
                        "value": _video,
                        "videoType": $video.attr("data-video-type")
                    }

                    players.push(_op);
                }

                if($video.data("video-type") == "youtube") {
                    var _mute = 0, _controls = 1;
                    if($video.is('[data-autoplay]')) {
                        _mute = 1;
                        _controls = 0;
                    }

                    _ele = $video;

                    var _newBGId = $video.attr("id") + _prefix;
                    var _videoBox = $('<div id="bg-'+ _newBGId +'"></div>');
                    $video.append(_videoBox);
                  
                    _backgroundPlayer = new YT.Player('bg-' + _newBGId, {
                        width: "100%",
                        height: "100%",
                        videoId: $video.attr("id"),
                        playerVars: {
                            'loop': 1,
                            'autoplay': 0,
                            'controls': _controls,
                            'enablejsapi': 1,
                            'playsinline': 1,
                            'rel': 0,
                            'showinfo': 0,
                            'mute': _mute,
                            'modestbranding': 1,
                            'playlist': $video.attr("data-id")
                        },
                        events: {
                            'onReady': onPlayerReady
                        }
                    });

                    function onPlayerReady(event) {
                        _ele.addClass('ready');

                        if($video.is('[data-autoplay]')) {
                            _ele.addClass('playing');
                            _backgroundPlayer.playVideo();

                            setTimeout(function() {
                                _backgroundPlayer.playVideo();
                            }, 500);
                        }
                    }
                    
                    _size = calcVideoSize($video);
                    _backgroundPlayer.setSize(_size[0],_size[1]);
                    $(window).resize(function(event) {
                        _size = calcVideoSize($video);
                        _backgroundPlayer.setSize(_size[0],_size[1]);
                    });

                    var _op = {
                        "key": _prefix,
                        "value": _backgroundPlayer,
                        "videoType": $video.attr("data-video-type")
                    }

                    players.push(_op);
                }

                $video.find('.btn.btn-play, [data-play]').on('click', function(event) {
                    event.preventDefault();
                    const prefix = $video.attr("data-prefix");

                    players.forEach(player => {
                        if (player.key === prefix) {
                            if(player.videoType == 'mp4') {
                                player.value.play();
                            } else if (player.videoType == 'youtube') {
                                player.value.playVideo();
                            }
                            _ele.addClass('playing').addClass('on');
                        }
                    });
                })
            }
        }

        getVideo(key) {
            let result = null;
            players.forEach(player => {
                if (player.key === key) {
                    result = player;
                }
            });

            console.log(result);

            return result;
        }
    }

    function closeVideo($ele, prefix) {
        const $close = $ele.find('[data-video-close]');
        $close.on('click', event => {
            event.preventDefault();
            players.forEach(player => {
                if (player.key === prefix) {
                    player.value.pauseVideo();
                }
            });
            $ele.removeClass('on');
        });
    }

    function fixMobileAutoplayLowerMode(video) {
        $('body').on('click touchstart', function () {
            if (!video.playing) {
                video.play();
            }
        });
    }

    return Videos;
})();

export default Videos;